import { useMediaQuery, useTheme } from "@mui/material";

export const useDeviceType = (): string => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("desktop"));
  const isTablet = useMediaQuery(theme.breakpoints.between("desktop", "lg"));

  if (isMobile) return "Mobile";
  if (isTablet) return "Tablet";
  return "Desktop";
};
